<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-col>
        <v-row no-gutters>
            <v-col cols="12">
                <v-data-table
                    :items="activities"
                    hide-default-footer
                    :items-per-page="-1"
                    hide-default-header
                    class="medium-dense-table"
                >
                    <template v-slot:item="{ item }">
                        <tr :class="{ 'cursor-pointer': isActivityClickable(item) }" @click="onRowClick(item)">
                            <td class="pl-1" style="max-width: 31px; width: 31px;">
                                <AccountAvatar
                                    :initials="item.client_initials ? item.client_initials : item.creator_initials"
                                    :color="item.color ? item.color : 'grey'"
                                    size="31"
                                    tile
                                />
                            </td>
                            <td style="max-width: 150px;">
                                <span class="text-uppercase caption font-weight-medium">
                                    {{ item.client_name ? item.client_name : $t("Me") }}
                                </span>
                            </td>
                            <td>
                                <v-row no-gutters align="center">
                                    <span v-if="item.task_title" class="font-weight-medium mr-5">
                                        {{ firstUpper(item.task_title) }}
                                    </span>
                                    <div>
                                        <DotStatus
                                            :color="getActivityTypeColor(item.type)"
                                            :text="firstUpper(item.message)"
                                            left-dot
                                        />
                                    </div>
                                </v-row>
                            </td>
                            <td class="font-weight-regular text-right">
                                <v-row style="flex-wrap: nowrap; white-space: nowrap;" justify="center">
                                    <span class="grey--text">@{{ item.created_at | format_time }}</span>
                                    <span class="ml-1 grey--text text--darken-3">
                                        {{ item.created_at | format_date_short }}
                                    </span>
                                </v-row>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
import { onMounted } from "@vue/composition-api";
import AccountAvatar from "../../components/AccountAvatar";
import ActivityModule from "../../store/modules/activity";
import DotStatus from "../../components/DotStatus";

export default {
    name: "ActivityLogView",
    components: {
        DotStatus,
        AccountAvatar
    },
    setup() {
        const { fetchActivities, activities, navigateToActivitySource } = ActivityModule();
        const firstUpper = str => {
            return str.charAt(0).toUpperCase() + str.slice(1);
        };
        const isActivityClickable = activity => activity.related_type === "task";
        const onRowClick = item => {
            if (isActivityClickable(item)) {
                navigateToActivitySource(item);
            }
        };
        const getActivityTypeColor = type => {
            const task_types = [
                "task_created",
                "task_updated",
                "task_assigned",
                "task_reminder",
                "task_finished",
                "task_in_progress",
                "task_comment",
                "task_delegated",
                "task_deleted"
            ];
            const task_template_types = [
                "plan_created",
                "plan_deleted",
                "task_template_created",
                "task_template_deleted"
            ];
            const client_types = [
                "client_created",
                "client_updated",
                "client_assigned",
                "client_deactivated",
                "client_deleted"
            ];
            const account_types = ["new_account", "company_account_deleted", "login", "invitation_accepted"];
            if (task_types.includes(type)) {
                return "primary--text";
            } else if (task_template_types.includes(type)) {
                return "purple--text";
            } else if (client_types.includes(type)) {
                return "tretiary--text";
            } else if (account_types.includes(type)) {
                return "secondary--text";
            } else {
                return "black--text";
            }
        };
        onMounted(() => {
            fetchActivities();
        });
        return {
            activities,
            firstUpper,
            getActivityTypeColor,
            onRowClick,
            isActivityClickable
        };
    }
};
</script>
